import { GzBulletWebComponent } from './component/GzBulletWebComponent';

export { GzBulletWebComponent };
